
import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom'
import * as moment from 'moment'
import {
  Redirect,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'

import { setDialogConfirmationStepChange } from '../../actions/action'
import ConfirmationDialog from './ConfirmationDialog'
import { isExistPrestationWithForfait } from '../../helpers/functions'
import { pushEventToGTM } from '../../helpers/trackerManager'

const mapStateToProps = state => state
const mapDispatchToProps = { setDialogConfirmationStepChange }

class Breadcrumb extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      redirectToLocation: false,
      expiredDate: false
    }
    this.confirmAndRedirect = this.confirmAndRedirect.bind(this);
    this.verifyRDVdateLimit = this.verifyRDVdateLimit.bind(this);
  }

  componentDidMount() {

  }

  verifyRDVdateLimit() {
    var dateLimit = this.props.store.dateLimitModif;
    if (this.props.store.isEditMode) {
      var limit = moment(dateLimit).format('YYYY/MM/DD');
      var now = moment().format('YYYY/MM/DD');
      if (now < limit) {
        this.setState({ expiredDate: false });
      } else {
        this.setState({ expiredDate: true });
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.redirectToLocation) { this.setState({ redirectToLocation: false }) }
  }

  componentWillReceiveProps(nextProps) {
    this.setState((state, props) => { return { showDialog: (props.stepDialogVisible == props.stepNumber) } });

  }

  breadcrumbItemContent(isdisactived) {
    return <>
      <i className={'mark-icons arrowNav-icon' + 
        (this.props.brand === "C" && (this.props.currentStep > this.props.stepNumber) ? " checkmark-done" : "") } step={`${this.props.stepNumber}`}  onClick={(e) => {
          if(this.props.brand === "C" && window.isMobile() === "mobile"){
            pushEventToGTM({
              pageName: 'all',
              eventAction: 'Redirection::Internal::Crumbtrail',
              eventLabel: this.props.eventLabel
            })
            if (isExistPrestationWithForfait(this.props.store.SelectedServices) && this.props.stepNumber <= 3) { this.props.setDialogConfirmationStepChange(this.props.stepNumber) } else if (this.props.currentStep > this.props.stepNumber && !this.state.expiredDate) {
              this.setState({ redirectToLocation: true })
              this.props.onClick()
            }
          }
        }} />
      <h4
        tabIndex="0"
        className='breadcrumb-item--title'
        aria-disabled={isdisactived ? "true" : "false"}
        style={{
          fontWeight : this.props.brand === "C" && (this.props.currentStep > this.props.stepNumber) ? "normal" : undefined,
          display : this.props.brand === "C" &&  (this.props.currentStep > this.props.stepNumber) && window.isMobile() == 'mobile' ? "none" : undefined
        }}
        onClick={(e) => {
          pushEventToGTM({
            pageName: 'all',
            eventAction: 'Redirection::Internal::Crumbtrail',
            eventLabel: this.props.eventLabel
          })
          if (isExistPrestationWithForfait(this.props.store.SelectedServices) && this.props.stepNumber <= 3) { this.props.setDialogConfirmationStepChange(this.props.stepNumber) } else if (this.props.currentStep > this.props.stepNumber && !this.state.expiredDate) {
            this.setState({ redirectToLocation: true })
            this.props.onClick()
          }
        }}
        onKeyDown={(e) => {
          if(e.key === 'Enter'){
            pushEventToGTM({
              pageName: 'all',
              eventAction: 'Redirection::Internal::Crumbtrail',
              eventLabel: this.props.eventLabel
            })
            if (isExistPrestationWithForfait(this.props.store.SelectedServices) && this.props.stepNumber <= 3) { this.props.setDialogConfirmationStepChange(this.props.stepNumber) } else if (this.props.currentStep > this.props.stepNumber && !this.state.expiredDate) {
              this.setState({ redirectToLocation: true })
              this.props.onClick()
            }
          }
        }}
      >
        {this.props.title}
      </h4>
    </>
  }

  confirmAndRedirect(isRedirect) {
    if (isRedirect && !this.state.expiredDate) {
      this.setState({ redirectToLocation: true })
      this.props.onClick()
    }

    // Reset id of visible dialog step change.
    this.props.setDialogConfirmationStepChange('')
  }

  render() {
    { this.verifyRDVdateLimit() }
    if (this.props.currentStep >= this.props.stepNumber && this.props.isEnabled) {

      return (
        <React.Fragment>
          <li className={'breadcrumb-item' + (this.props.currentStep < this.props.stepNumber || this.state.expiredDate
            ? ' isDisabled' : '')}
          >
            {this.state.redirectToLocation &&
              <Switch>
                <Redirect
                  push
                  to={{ pathname: String(this.props.link) }}
                />
              </Switch>}
            {this.breadcrumbItemContent(this.props.currentStep < this.props.stepNumber || this.state.expiredDate)}

            {this.props.store.visibaleDialogId == this.props.stepNumber &&
              (this.props.currentStep > this.props.stepNumber) &&
              isExistPrestationWithForfait(this.props.store.SelectedServices) &&
              this.props.stepNumber <= 3 &&
              <ConfirmationDialog isConfirmedDialog={(e) => {
                this.confirmAndRedirect(e)
              }}
              />}
          </li>
          {this.props.brand === "C" && this.props.stepNumber < this.props.totalSteps && <div className={'breadcrumb-separator' + 
          ((this.props.currentStep !==1 && this.props.currentStep <= this.props.stepNumber) || this.state.expiredDate
            ? ' isDisabled' : '')}></div>}
        </React.Fragment>
      
      )
    } else {
      return (
        <React.Fragment>
          <div className={'breadcrumb-item' + (this.props.currentStep < this.props.stepNumber || !this.props.isEnabled
            ? ' isDisabled' : ' ')}
          >
            {this.breadcrumbItemContent(this.props.currentStep < this.props.stepNumber || this.state.expiredDate)}
          </div>
          
          {this.props.brand === "C" && 
          this.props.stepNumber < this.props.totalSteps && 
            <div className={'breadcrumb-separator' + (this.props.currentStep < this.props.stepNumber || !this.props.isEnabled
            ? ' isDisabled' : '')}></div>}
        </React.Fragment>
      )
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb)
